// AUTO-GENERATED by scripts/gen-depth-index.mjs — do not edit by hand.
export type DepthGroup = "a" | "b" | "c" | "d" | "e" | "f" | "g" | "h" | "i" | "j" | "k" | "l";

export const DEPTH_GROUP_BY_SLUG: Record<string, DepthGroup> = {
  "accounting-tax-monthly": "k",
  "airport-fast-track": "k",
  "apec-card": "k",
  "bank-account-opening": "c",
  "boi-application": "e",
  "company-registration-thai": "c",
  "contract-drafting-nda": "k",
  "corporate-due-diligence": "k",
  "council-architect": "e",
  "council-engineer": "e",
  "council-lawyer-bar": "l",
  "council-nursing": "e",
  "council-pharmacy": "l",
  "council-teacher": "e",
  "driver-license-conversion": "c",
  "embassy-all-countries": "l",
  "embassy-legalization": "b",
  "expat-relocation-package": "l",
  "foreign-business-license": "e",
  "government-certification": "l",
  "insurance-o-a-ltr": "l",
  "interpreter-academic": "i",
  "interpreter-amphur": "e",
  "interpreter-business-consecutive": "i",
  "interpreter-court": "d",
  "interpreter-immigration": "e",
  "interpreter-medical": "i",
  "interpreter-property": "i",
  "interpreter-remote": "i",
  "interpreter-simultaneous": "i",
  "marriage-abroad": "j",
  "marriage-australia": "f",
  "marriage-denmark": "f",
  "marriage-france": "f",
  "marriage-germany": "f",
  "marriage-hongkong": "j",
  "marriage-japan": "f",
  "marriage-korea": "f",
  "marriage-las-vegas": "j",
  "marriage-netherlands": "f",
  "marriage-new-zealand": "j",
  "marriage-norway": "j",
  "marriage-registration": "b",
  "marriage-service": "j",
  "marriage-singapore": "j",
  "marriage-sweden": "f",
  "marriage-switzerland": "f",
  "marriage-taiwan": "j",
  "marriage-uk": "f",
  "medical-concierge": "l",
  "medical-council": "l",
  "mfa-consular": "a",
  "mfa-consular-en": "i",
  "moj-translator": "h",
  "naati-online": "h",
  "notary-affidavit": "b",
  "notary-apostille-poa": "a",
  "notary-e-signature": "i",
  "notary-oath-statutory": "i",
  "notary-poa-cross-border": "b",
  "notary-public": "a",
  "notary-public-english": "i",
  "pension-overseas": "l",
  "police-bundle": "j",
  "police-clearance": "b",
  "police-clearance-intl": "j",
  "property-conveyancing-foreigner": "e",
  "re-entry-permit": "k",
  "residence-certificate": "l",
  "school-placement": "l",
  "sworn-austria": "h",
  "sworn-belgium": "h",
  "sworn-france": "d",
  "sworn-germany": "d",
  "sworn-italy": "h",
  "sworn-netherlands": "h",
  "sworn-spain": "h",
  "sworn-switzerland": "h",
  "tat-license": "k",
  "thai-visa": "l",
  "tm30-90day-report": "b",
  "trademark-madrid": "k",
  "translation-all": "h",
  "translation-certified-all": "a",
  "translation-government": "h",
  "translation-visa": "d",
  "treaty-of-amity": "e",
  "visa-australia-600": "g",
  "visa-business-b": "d",
  "visa-canada": "g",
  "visa-china-l": "g",
  "visa-consult-foreign": "g",
  "visa-consult-thai": "l",
  "visa-dependent": "g",
  "visa-dtv": "a",
  "visa-ed-student": "d",
  "visa-elite": "g",
  "visa-japan-tourist": "g",
  "visa-korea-c3": "g",
  "visa-ltr": "c",
  "visa-marriage-o": "d",
  "visa-metv": "g",
  "visa-retirement": "b",
  "visa-schengen": "d",
  "visa-smart": "c",
  "visa-uk-visitor": "g",
  "visa-us-b1b2": "c",
  "will-inheritance": "c",
  "work-experience-cert": "k",
  "work-permit": "a",
  "work-permit-amend": "k",
};
